import { Botao } from '../../../components/Botao'
import { Dialogo } from '../../../components/Dialogo'

/**
 * Uma pausa antes de um ato cujas consequências não estão à vista.
 *
 * Fechar o mês não é irreversível — reabrir existe —, e mesmo assim pede confirmação: o que muda
 * não é óbvio na tela. A partir do fechamento, julgamento novo naquele mês passa a ser recusado, e
 * o fiscal que estivesse no meio da conferência descobriria isso pelo erro, dois cliques depois.
 *
 * A confirmação EXPLICA, e não só pergunta "tem certeza?". Um diálogo que só pergunta vira um
 * clique automático na terceira vez.
 *
 * @param props título, explicação e o que fazer ao confirmar
 * @returns o diálogo
 */
export function DialogoDeConfirmacao({
  titulo,
  ajuda,
  confirmar,
  aoConfirmar,
  aoFechar,
}: {
  titulo: string
  ajuda: string
  confirmar: string
  aoConfirmar: () => void
  aoFechar: () => void
}) {
  return (
    <Dialogo titulo={titulo} aoFechar={aoFechar}>
      <div className="space-y-4">
        <p className="max-w-prose text-sm text-slate-600">{ajuda}</p>
        <div className="flex flex-wrap gap-2">
          <Botao aparencia="primario" onClick={aoConfirmar}>
            {confirmar}
          </Botao>
          <Botao onClick={aoFechar}>Cancelar</Botao>
        </div>
      </div>
    </Dialogo>
  )
}
